export default "__VITE_ASSET__DDOoXPp8__"